import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './index.css';


const Preview = (props) => {
  const {
    coverImageUrl,
    hasAccess,
    id,
    onClick,
  } = props;

  const previewClasses = classNames({
    [styles.preview]: true,
    [styles.blur]: !hasAccess,
  });

  const style = { backgroundImage: `url(${coverImageUrl})` };

  return (
    <div
      className={previewClasses}
      id={id}
      style={style}
      onClick={onClick}
    />
  );
};

Preview.propTypes = {
  id: PropTypes.string.isRequired,
  coverImageUrl: PropTypes.string,
  hasAccess: PropTypes.bool,
  onClick: PropTypes.func,
};

Preview.defaultProps = {
  coverImageUrl: undefined,
  hasAccess: false,
  onClick: () => undefined,
};

export default memo(Preview);
